var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5336 2.66658H10.6003V10.9332H3.4C2.86666 10.9332 2.33333 11.4665 2.33333 11.9999V12.9332H10.6003L10.6003 20.2666C10.6003 20.7999 11.0003 21.3333 11.6669 21.3333H12.6003L12.6003 12.9332L19.9333 12.9332C20.4667 12.9332 21 12.5332 21 11.8665V10.9332L12.6003 10.9332V3.73325C12.6003 3.19992 12.2003 2.66658 11.5336 2.66658Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.0b60c7dbeca1ef461c3ebfc25ddf972b.svg";
export { ForwardRef as ReactComponent };